import { ApiTemplateCustomization, EnumValueType } from './Generated';
import { decodeValue, encodeValue } from './IApiValued';

import { fromBase64, toBase64 } from 'js-base64';

export function encode(customization: ApiTemplateCustomization) {
    const encoded = encodeValue(customization);

    if (customization.type === EnumValueType.Html) {
        encoded.source = toBase64(customization.source);
    }

    return encoded;
}

export function encodeAll(customizations: ApiTemplateCustomization[]) {
    return customizations.map(encode);
}

export function decode(customization: ApiTemplateCustomization) {
    const decoded = decodeValue(customization);

    if (customization.type === EnumValueType.Html) {
        decoded.source = fromBase64(customization.source);
    }

    return decoded;
}

export function decodeAll(customizations: ApiTemplateCustomization[]) {
    return customizations.map(decode);
}
